var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_vm._v(" "+_vm._s(_vm.$options.name)+" "),_c('p',[_vm._v("TODO: setup view")])])}
var staticRenderFns = []

export { render, staticRenderFns }